<template>
    <div
        class="kpi-card"
        :class="`kpi-card--${variant}`"
        role="region"
        :aria-label="label"
    >
        <span class="kpi-card__value" aria-live="polite">{{ value }}</span>
        <span class="kpi-card__label">{{ label }}</span>
    </div>
</template>

<script>
export default {
    name: 'KpiCard',
    props: {
        value: { type: [Number, String], default: 0 },
        label: { type: String, required: true },
        variant: {
            type: String,
            default: 'default',
            validator: (v) => ['default', 'danger', 'warning'].includes(v)
        }
    }
}
</script>

<style scoped>
.kpi-card {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.1rem 0.75rem;
    background: #1a1a1a;
    border: 1px solid #2a2a2a;
    border-radius: 8px;
    cursor: default;
    animation: kpiEntrance 0.35s cubic-bezier(0.0, 0.0, 0.2, 1) both;
    transition: border-color 0.2s, box-shadow 0.2s;
    min-width: 0;
}

.kpi-card:hover {
    border-color: #555555;
    box-shadow: 0 0 0 3px rgba(85, 85, 85, 0.12);
}

.kpi-card--danger:hover {
    border-color: #f85149;
    box-shadow: 0 0 0 3px rgba(248, 81, 73, 0.12);
}

.kpi-card__value {
    font-size: 1.9rem;
    font-weight: 700;
    color: #e6edf3;
    line-height: 1;
    margin-bottom: 0.35rem;
}

.kpi-card__label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #f97316;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    text-align: center;
}

.kpi-card--danger .kpi-card__label {
    color: #f85149;
}

.kpi-card--warning .kpi-card__label {
    color: #e3b341;
}

@keyframes kpiEntrance {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
    .kpi-card { animation: none; transition: none; }
}
</style>
